import React from 'react';
import Reveal from '@/components/common/Reveal';

interface ContactHeroProps {
  title: string;
  subtitle: string;
}

const ContactHero: React.FC<ContactHeroProps> = ({ title, subtitle }) => {
  return (
    <section className="relative min-h-[20vh] flex items-center justify-center overflow-hidden bg-linear-to-b from-background via-muted to-background">
      <Reveal className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="font-headline text-2xl md:text-3xl font-bold text-foreground leading-tight mb-4">
          {title}
        </h1>
        <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      </Reveal>
    </section>
  );
};

export default ContactHero;
